// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/approvals/:context_id/(:step)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementApprovalsContextIdStep } from "./constants";
import type { EngagementApprovalsContextIdStepResult } from "./types";
import { approvalStatuses } from "./types";
import { isSingleApprovalRecord } from "./validators";

export const getEngagementApprovalsStep = reactQueryFetcherAdapter(
  engagementApprovalsContextIdStep,
  (
    signal: AbortSignal,
    contextId: string,
    step?: string,
    cacheKey?: string
  ): Promise<EngagementApprovalsContextIdStepResult> => {
    return fetch(
      `/engagement/approvals/${contextId}/${step}`,
      "GET",
      {
        cache_key: cacheKey,
      },
      { signal }
    ).then((data) => {
      // @note: since this endpoint returns empty object when not found,
      // we'll want to default to pending if nothing is returned back.
      if (step && !isSingleApprovalRecord(data)) {
        return {
          status: approvalStatuses.PENDING,
          developer_id: null,
        };
      }
      return data;
    });
  }
);
